import { Colors, HintTooltip } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, ReactNode } from "react";
import styled, { css } from "styled-components";
import { CheckboxRoot } from 'shared/components/CookiesWarning/CookiesWarning';
import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as CheckIconWhite } from "../../../assets/checkWhite.svg";
import { AppTester } from "supporting";

export const OkButtonWrapper = styled.div`
  height: 58px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const OkButton = styled.div<{ disabled: boolean, isGeo?: boolean, isContinuumSite?: boolean }>`
  border-radius: 3px;
  padding: 8px 46px 8px 46px;
  background-color: ${p => p.isGeo ? "#A4B54D" : p.isContinuumSite ? "#FFFFFF" : "#1F1F1F"};
  cursor: pointer;
  
  font-family: Inter;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: center;
  color: ${p => p.isGeo ? Colors.geo : p.isContinuumSite ? '#151514' : "#FFF"};

  width: 100%;
  margin: 0 16px;

  pointer-events: ${({ disabled }) => disabled ? 'none' : 'all'};

  @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
    padding: 8px 51px 8px 51px;
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 8px 24px 8px 24px;
  }
`;

export const Outer = styled.div<{ isGeo?: boolean, isContinuumSite?: boolean, fullWidth?: boolean }>`
  background: ${p => p.isGeo ? Colors.geoWhite10 : p.isContinuumSite ?'#1f1f1f' : Colors.galBlack5};
  padding-top: 10px;
  width: ${p => p.fullWidth ? '100%' : '400px'};
  z-index: 99999;
  border-radius: 3px;

  div {
    user-select: none;
  }

  @media screen and (max-width: ${LayoutConst.screen.l}px) and (min-width: 920px) {
    width: ${p => p.fullWidth ? '100%' : '300px'};
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    width: ${p => p.fullWidth ? '100%' : '300px'};
  }
`;

export const TooltipList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 288px;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Colors.galBlack47};
  }
`

export const RowTitle = styled.div<{ isGeo?: boolean, isContinuumSite?: boolean; infoComponent?: boolean }>`
  font-family: Inter;
  margin-left: 40px;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: left;
  color: ${p => p.isGeo ? Colors.gal : Colors.galBlack61};

  ${({ infoComponent }) => infoComponent && css`
    display: flex;
    flex-flow: row;
    align-items: center;

    .info-icon-wrapper {
      margin-left: 8px;
    }
  `};

  @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 13px;
    line-height: 16px;
  }
`

export const MagicBoxRowWrapper = styled.div<{ isGeo?: boolean, isContinuumSite?: boolean; disabled?: boolean, isTeamEdit?: boolean }>`
  min-height: fit-content;
  box-sizing: content-box;
  padding: 12px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 16px;
  transition: 0.2s;

  ${({ isTeamEdit }) => isTeamEdit ? css`
  padding-left: 0 !important;
` : null};

  ${({ disabled}) => disabled ? css`
    pointer-events: none;
    user-select: none;
  ` : null};
  
  :hover {
    background-color: ${p => p.isGeo ? Colors.geoWhite5 : "#EEE"};
    ${(p) => p.theme.themeName === 'jhonataTheme' && css`
          background-color: ${Colors.zelWhite21};
    `}
    ${(p) => p.isContinuumSite && css`
          color: #8E9193;
          background-color: ${Colors.zelWhite10};
    `}
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      padding-left: 0 !important;
      width: 100%;
    ` : null};
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    height: auto;
    gap: 8px;
  }
`

export const CheckboxRowWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
`

interface MagicBoxRowPropsT {
  onClick: (e?: any) => void;
  checked: boolean;
  label: string;
  disabled?: boolean;
  isTeamEdit?: boolean;
  className?: string;
  hintsText?: string;
  positionY?: 'bottom' | 'top' | 'default';
  component?: ReactNode;
}

export const MagicBoxRow: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, disabled, isTeamEdit, className, hintsText, positionY, component }) => {
  const isGeo = AppTester.isGeograffee() && !AppTester.isGeoDafes();
  const isContinuumSite = AppTester.isContinuumSite();

  if (hintsText) {
   return (
      <HintTooltip text={hintsText} z={100} onWhiteBg positionY={positionY}>
        <MagicBoxRowWrapper className={className} isGeo={isGeo} isContinuumSite={isContinuumSite} onClick={onClick} disabled={disabled} isTeamEdit={isTeamEdit}>
        
          <CheckboxRoot style={{position: "absolute"}} isGeo={isGeo} isContinuumSite={isContinuumSite} checked={checked} disabled={disabled}>
            {checked && (isGeo || isContinuumSite ? <CheckIconWhite/> : <CheckIcon/>)}
            <input checked={checked} type="checkbox"/>
          </CheckboxRoot>
          <RowTitle isGeo={isGeo}>
            {label}
            {component && component}
          </RowTitle>
      </MagicBoxRowWrapper>
      </HintTooltip>
   )
  }

  return (
    <MagicBoxRowWrapper className={className} isGeo={isGeo} isContinuumSite={isContinuumSite} disabled={disabled} isTeamEdit={isTeamEdit}>
      <CheckboxRoot style={{position: "absolute"}} isGeo={isGeo} isContinuumSite={isContinuumSite} onClick={onClick} checked={checked} disabled={disabled}>
        {checked && (isGeo || isContinuumSite ? <CheckIconWhite/> : <CheckIcon/>)}
        <input checked={checked} type="checkbox"/>
      </CheckboxRoot>
      <RowTitle infoComponent={!!component} isGeo={isGeo} isContinuumSite={isContinuumSite} >
        {label}
        {component && component}
      </RowTitle>
    </MagicBoxRowWrapper>
  )
}
import { Colors, HintTooltip } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, ReactNode } from "react";
import styled, { css } from "styled-components";
import { CheckboxRoot } from 'shared/components/CookiesWarning/CookiesWarning';
import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as CheckIconWhite } from "../../../assets/checkWhite.svg";
import { AppTester } from "supporting";

export const OkButtonWrapper = styled.div`
  height: 58px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const OkButton = styled.div<{ disabled: boolean, isGeo?: boolean, isContinuumSite?: boolean }>`
  border-radius: 3px;
  padding: 8px 46px 8px 46px;
  background-color: ${p => p.isGeo ? "#A4B54D" : p.isContinuumSite ? "#FFFFFF" : "#1F1F1F"};
  cursor: pointer;
  
  font-family: Inter;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: center;
  color: ${p => p.isGeo ? Colors.geo : p.isContinuumSite ? '#151514' : "#FFF"};

  width: 100%;
  margin: 0 16px;

  pointer-events: ${({ disabled }) => disabled ? 'none' : 'all'};

  @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
    padding: 8px 51px 8px 51px;
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 8px 24px 8px 24px;
  }
`;

export const Outer = styled.div<{ isGeo?: boolean, isContinuumSite?: boolean, fullWidth?: boolean }>`
  background: ${p => p.isGeo ? Colors.geoWhite10 : p.isContinuumSite ?'#1f1f1f' : Colors.galBlack5};
  padding-top: 10px;
  width: ${p => p.fullWidth ? '100%' : '400px'};
  z-index: 99999;
  border-radius: 3px;

  div {
    user-select: none;
  }

  @media screen and (max-width: ${LayoutConst.screen.l}px) and (min-width: 920px) {
    width: ${p => p.fullWidth ? '100%' : '300px'};
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    width: ${p => p.fullWidth ? '100%' : '300px'};
  }
`;

export const TooltipList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 288px;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Colors.galBlack47};
  }
`

export const RowTitle = styled.div<{ isGeo?: boolean, isContinuumSite?: boolean; infoComponent?: boolean }>`
  font-family: Inter;
  margin-left: 40px;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: left;
  color: ${p => p.isGeo ? Colors.gal : Colors.galBlack61};

  ${({ infoComponent }) => infoComponent && css`
    display: flex;
    flex-flow: row;
    align-items: center;

    .info-icon-wrapper {
      margin-left: 8px;
    }
  `};

  @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 13px;
    line-height: 16px;
  }
`

export const MagicBoxRowWrapper = styled.div<{ isGeo?: boolean, isContinuumSite?: boolean; disabled?: boolean, isTeamEdit?: boolean }>`
  min-height: fit-content;
  box-sizing: content-box;
  padding: 12px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 16px;
  transition: 0.2s;

  ${({ isTeamEdit }) => isTeamEdit ? css`
  padding-left: 0 !important;
` : null};

  ${({ disabled}) => disabled ? css`
    pointer-events: none;
    user-select: none;
  ` : null};
  
  :hover {
    background-color: ${p => p.isGeo ? Colors.geoWhite5 : "#EEE"};
    ${(p) => p.theme.themeName === 'jhonataTheme' && css`
          background-color: ${Colors.zelWhite21};
    `}
    ${(p) => p.isContinuumSite && css`
          color: #8E9193;
          background-color: ${Colors.zelWhite10};
    `}
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      padding-left: 0 !important;
      width: 100%;
    ` : null};
  }

  @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    height: auto;
    gap: 8px;
  }
`

export const CheckboxRowWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
`

interface MagicBoxRowPropsT {
  onClick: (e?: any) => void;
  checked: boolean;
  label: string;
  disabled?: boolean;
  isTeamEdit?: boolean;
  className?: string;
  hintsText?: string;
  positionY?: 'bottom' | 'top' | 'default';
  component?: ReactNode;
}

export const MagicBoxRow: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, disabled, isTeamEdit, className, hintsText, positionY, component }) => {
  const isGeo = AppTester.isGeograffee() && !AppTester.isGeoDafes();
  const isContinuumSite = AppTester.isContinuumSite();

  if (hintsText) {
   return (
      <HintTooltip text={hintsText} z={100} onWhiteBg positionY={positionY}>
        <MagicBoxRowWrapper className={className} isGeo={isGeo} isContinuumSite={isContinuumSite} onClick={onClick} disabled={disabled} isTeamEdit={isTeamEdit}>
        
          <CheckboxRoot style={{position: "absolute"}} isGeo={isGeo} isContinuumSite={isContinuumSite} checked={checked} disabled={disabled}>
            {checked && (isGeo || isContinuumSite ? <CheckIconWhite/> : <CheckIcon/>)}
            <input checked={checked} type="checkbox"/>
          </CheckboxRoot>
          <RowTitle isGeo={isGeo}>
            {label}
            {component && component}
          </RowTitle>
      </MagicBoxRowWrapper>
      </HintTooltip>
   )
  }

  return (
    <MagicBoxRowWrapper className={className} isGeo={isGeo} isContinuumSite={isContinuumSite} disabled={disabled} isTeamEdit={isTeamEdit}>
      <CheckboxRoot style={{position: "absolute"}} isGeo={isGeo} isContinuumSite={isContinuumSite} onClick={onClick} checked={checked} disabled={disabled}>
        {checked && (isGeo || isContinuumSite ? <CheckIconWhite/> : <CheckIcon/>)}
        <input checked={checked} type="checkbox"/>
      </CheckboxRoot>
      <RowTitle infoComponent={!!component} isGeo={isGeo} isContinuumSite={isContinuumSite} >
        {label}
        {component && component}
      </RowTitle>
    </MagicBoxRowWrapper>
  )
}
